
export const GET_ALLPRODUCTS_REQUEST = "GET_ALLPRODUCTS_REQUEST";
export const GET_ALLPRODUCTS_SUCCESS = "GET_ALLPRODUCTS_SUCCESS";
export const GET_ALLPRODUCTS_FAILURE = "GET_ALLPRODUCTS_FAILURE";

export const PATCH_PRODUCT_SUCCESS = 'PATCH_PRODUCT_SUCCESS'
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";

export const ADD_ALLPRODUCTS_REQUEST = "GET_ALLPRODUCTS_REQUEST";
export const ADD_ALLPRODUCTS_SUCCESS = "GET_ALLPRODUCTS_SUCCESS";
export const ADD_ALLPRODUCTS_FAILURE = "GET_ALLPRODUCTS_FAILURE";